import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
    defaultLanguage,
    defaultNS,
    languageStorageKey,
    ns,
    supportedLanguages,
    type SupportedLanguage,
} from './constants';
import { defaultResource } from './defaultResource';

const isSupportedLanguage = (language: string): language is SupportedLanguage => {
    return supportedLanguages.includes(language as SupportedLanguage)
}

const resolveInitialLanguage = (): SupportedLanguage => {
    if (typeof window === 'undefined') {
        return defaultLanguage
    }

    const storedLanguage = window.localStorage.getItem(languageStorageKey)

    if (!storedLanguage || !isSupportedLanguage(storedLanguage)) {
        return defaultLanguage
    }

    return storedLanguage
}

const persistLanguage = (language: SupportedLanguage) => {
    if (typeof window === 'undefined') {
        return
    }

    window.localStorage.setItem(languageStorageKey, language)
}

i18n.use(initReactI18next).init({
    defaultNS,
    lng: resolveInitialLanguage(),
    fallbackLng: defaultLanguage,
    ns,
    resources: defaultResource,
    supportedLngs: supportedLanguages,
    react: {
        useSuspense: false
    }
})

export const changeAppLanguage = async (language: string) => {
    if (!isSupportedLanguage(language)) {
        return i18n.resolvedLanguage || i18n.language || defaultLanguage
    }

    await i18n.changeLanguage(language)
    persistLanguage(language)

    return language
}

export default i18n

